
import { useEffect, useState } from "react";

export const useConsentDetection = () => {
  const [consentHandled, setConsentHandled] = useState(false);

  useEffect(() => {
    // Wait a short time before checking for consent banners to ensure they've loaded
    const initialCheckTimeout = setTimeout(() => {
      // Check if we're coming from a consent-related reload
      if (window.localStorage.getItem('consentJustHandled') === 'true') {
        console.log('Page reloaded after consent handling, triggering WhatsApp popup');
        window.localStorage.removeItem('consentJustHandled');
        
        // Add a delay before setting consentHandled to true to ensure consent popup is fully gone
        setTimeout(() => {
          setConsentHandled(true);
        }, 1000);
        return;
      }

      // More comprehensive selector for consent banners
      const consentBanner = document.querySelector(
        '.fc-consent-root, .fc-dialog, #cookieChoiceInfo, .cookie-consent-banner, ' +
        '.cc-window, .gdpr-consent-banner, #consent-banner, #cookie-banner, ' +
        '[aria-label*="cookie"], [aria-label*="consent"], [id*="cookie"], [id*="consent"], ' +
        '[class*="cookie"], [class*="consent"], [data-testid*="cookie"], [data-testid*="consent"]'
      );
      
      if (consentBanner) {
        console.log('Consent banner detected on initial load, setting flag');
        window.localStorage.setItem('consentDetected', 'true');
        // Don't set consentHandled to true if consent banner is present
      } else if (window.localStorage.getItem('consentDetected') === 'true') {
        // Banner was present before but now gone - reload to trigger WhatsApp popup
        console.log('Consent was previously detected but now gone - reloading');
        window.localStorage.removeItem('consentDetected');
        
        // Set flag in localStorage to indicate we're reloading after consent
        window.localStorage.setItem('consentJustHandled', 'true');
        
        // Reload the page to trigger WhatsApp popup
        window.location.reload();
        return;
      } else {
        // No consent banner detected and not in a post-consent state, can show WhatsApp popup
        console.log('No consent banner detected, can show WhatsApp popup');
        setConsentHandled(true);
      }
    }, 500); // Wait 500ms for consent banners to load

    const checkConsentStatus = () => {
      // More comprehensive selector for consent banners
      const consentBanner = document.querySelector(
        '.fc-consent-root, .fc-dialog, #cookieChoiceInfo, .cookie-consent-banner, ' +
        '.cc-window, .gdpr-consent-banner, #consent-banner, #cookie-banner, ' +
        '[aria-label*="cookie"], [aria-label*="consent"], [id*="cookie"], [id*="consent"], ' +
        '[class*="cookie"], [class*="consent"], [data-testid*="cookie"], [data-testid*="consent"]'
      );
      
      if (!consentBanner && window.localStorage.getItem('consentDetected') === 'true') {
        console.log('Consent banner was present but now gone - reloading page');
        window.localStorage.removeItem('consentDetected');
        
        // Set flag in localStorage to indicate we're reloading after consent
        window.localStorage.setItem('consentJustHandled', 'true');
        
        // Reload the page to trigger WhatsApp popup
        window.location.reload();
      }
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          checkConsentStatus();
        }
      }
    });

    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true 
    });

    const intervalId = setInterval(checkConsentStatus, 300);

    document.addEventListener('click', checkConsentStatus);

    window.addEventListener('mousemove', checkConsentStatus, { once: true });
    window.addEventListener('scroll', checkConsentStatus, { once: true });

    return () => {
      clearTimeout(initialCheckTimeout);
      observer.disconnect();
      clearInterval(intervalId);
      document.removeEventListener('click', checkConsentStatus);
      window.removeEventListener('mousemove', checkConsentStatus);
      window.removeEventListener('scroll', checkConsentStatus);
    };
  }, []);

  return { consentHandled };
};
